import { FluidIconRef } from './components/fluid-icon.components';

/**
 * Returns the inline style map for the icon itself.
 */
export function getIconStyle() {
  return {
    [`icon-color-${this.color}`]: !!this.color,
    'inherit-icon-color': !this.color,
    disabled: this.disabled,
    interactive: !!this.interactive && !this.disabled,
  };
}

/**
 * Returns the inline style map for the icon container
 */
export function getIconContainerStyle() {
  return this.customStyles
    ? {
        marginTop: `${this.customStyles.marginTop}px`,
        marginBottom: `${this.customStyles.marginBottom}px`,
        marginLeft: `${this.customStyles.marginLeft}px`,
        marginRight: `${this.customStyles.marginRight}px`,
      }
    : undefined;
}

/**
 * Returns the class list for the icon container
 * @param iconRef
 */
export function getIconContainerClass(iconRef: FluidIconRef) {
  return {
    [`fluid-icon ${this.theme}`]: true,
    'icon-badge-container': this.includeAdornment,
    rotate: this.rotate,
    flipVertical: this.flipVertical,
    inline: this.inline,
    [`icon-size-${this.size}`]: true,
    [this.iconKey]: true,
    [`scale-${this.scale ?? iconRef?.scale}`]: true,
  };
}

/**
 * Returns the position modifier for the icon.
 */
export function getIconPosition() {
  return (
    this.position && {
      display: 'block',
      'margin-top': `${this.position.top}px`,
      'margin-bottom': `${this.position.bottom}px`,
      'margin-right': `${this.position.right}px`,
      'margin-left': `${this.position.left}px`,
    }
  );
}

/**
 * Returns the ARIA props for the icon
 */
export function getIconAriaProps() {
  const ariaLabel =
    this._i18nStore?.translate(this.fluidTranslate?.arialabel) ||
    this.arialabel;

  return ariaLabel ? { ariaLabel, ariaHidden: false } : { ariaHidden: true };
}
